import React, { useState } from "react";
import axios from "axios";
import Sidenav from "./SIdeNav";
import { useNavigate } from "react-router-dom";
import { useFormik, FieldArray, FormikProvider } from "formik";
import * as Yup from "yup";

import BackToAdmin from "./BackToAdmin";
import { toast, ToastContainer } from "react-toastify";

export const AddAttorneyForm = () => {
  const [isSidenavOpen, setIsSidenavOpen] = useState(false);

  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      name: "",
      Address: "",
      email: "",
      phone: "",
      website: "",
      // stateRegNumber: "",
      usptoRegNumber: "",
      patents: [{ number: "", patentName: "" }]
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      Address: Yup.string().required("Address is required"),
      email: Yup.string().email("Invalid email").required("Email is required"),
      phone: Yup.string()
        .matches(/^[0-9+\-\s()]{7,20}$/, "Invalid phone number")
        .required("Phone is required"),
      stateRegNumber: Yup.string().required(
        "State registration number is required"
      ),
      usptoRegNumber: Yup.string().required(
        "USPTO registration number is required"
      ),
      patents: Yup.array().of(
        Yup.object({
          number: Yup.string().required("Patent number is required"),
          patentName: Yup.string().required("Patent name is required")
        })
      )
    }),
    onSubmit: async (values) => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_PATH}/attorney`,
          values
        );
        if (response.status === 201) {
          toast.success("Attorney submitted ✅", { position: "top-right" });
          setTimeout(() => {
            navigate("/attorneys");
          }, 2000);
        }
      } catch (error) {
        console.error("Error saving data:", error);
      }
    },
  });

  const { values, touched, errors, handleChange, handleBlur, handleSubmit } =
    formik;

  return (
    <>
      <div className="flex flex-col lg:flex-row bg-white min-h-screen w-full flex-nowrap ">
        {/* Mobile Menu Icon */}
        <div className="lg:hidden bg-gray-800 text-white p-4 flex justify-between items-center">
          <h1 className="text-xl font-bold">Attorneys</h1>
          <button
            onClick={() => setIsSidenavOpen(!isSidenavOpen)}
            className="text-white p-2 rounded-md bg-gray-700 hover:bg-gray-600"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
        </div>
        <div
          className={`${
            isSidenavOpen
              ? "fixed inset-0 transform translate-x-0 bg-gray-800"
              : "fixed inset-0 transform -translate-x-full"
          } lg:relative lg:translate-x-0 lg:w-52  text-white p-4 transition-transform z-50`}
        >
          <Sidenav />
          <button
            onClick={() => setIsSidenavOpen(false)}
            className="lg:hidden absolute top-4 right-4 text-gray-300 hover:text-white"
          >
            Close
          </button>
        </div>
        <div className="flex-1 pl-2.5">
          <div
            className={`flex items-center justify-center pt-20 py-10 pb-3 ${
              isSidenavOpen ? "opacity-50 pointer-events-none" : ""
            } transition-opacity duration-300`}
          >
            <div className="pt-7"></div>

            <form
              onSubmit={handleSubmit}
              className="bg-white shadow-lg shadow-gray-700 rounded-lg p-5 pt-16 pl-8 space-y-6 w-[90%] mx-auto "
            >
              <div className="hidden lg:flex justify-between items-center bg-gray-800 p-3 -mt-20 rounded-lg ">
                <h2 className=" text-white font-semibold">Add Attorney</h2>
                <BackToAdmin />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Attorney Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="mt-1 block w-full border border-gray-300 rounded-xl p-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter attorney name"
                  />
                  {touched.name && errors.name && (
                    <p className="text-red-500 text-sm mt-1">{errors.name}</p>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="mt-1 block w-full border border-gray-300 rounded-xl p-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="name@example.com"
                  />
                  {touched.email && errors.email && (
                    <p className="text-red-500 text-sm mt-1">{errors.email}</p>
                  )}
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Address
                  </label>
                  <input
                    type="text"
                    name="Address"
                    value={values.Address}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="mt-1 block w-full border border-gray-300 rounded-xl p-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter attorney address"
                  />
                  {touched.Address && errors.Address && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.Address}
                    </p>
                  )}
                </div>

                <div className="mx-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Website
                  </label>
                  <input
                    type="text"
                    name="website"
                    value={values.website}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="mt-1 block w-full border border-gray-300 rounded-xl p-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Website url"
                  />
                  {touched.website && errors.website && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.website}
                    </p>
                  )}
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={values.phone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="mt-1 block w-full border border-gray-300 rounded-xl p-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="+1 555 123 4567"
                  />
                  {touched.phone && errors.phone && (
                    <p className="text-red-500 text-sm mt-1">{errors.phone}</p>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    USPTO Registration Number
                  </label>
                  <input
                    type="text"
                    name="usptoRegNumber"
                    value={values.usptoRegNumber}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="mt-1 block w-full border border-gray-300 rounded-xl p-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter USPTO registration number"
                  />
                  {touched.usptoRegNumber && errors.usptoRegNumber && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.usptoRegNumber}
                    </p>
                  )}
                </div>
              </div>
              <div className="grid grid-cols-1  gap-6">
              <FormikProvider value={formik}>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Patents
                  </label>
                  <FieldArray
                    name="patents"
                    render={(arrayHelpers) => (
                      <div>
                        {values.patents.map((att, index) => (
                          <div
                            key={index}
                            className="grid grid-cols-12 gap-3 items-center mt-2"
                          >
                            <input
                              type="text"
                              name={`patents[${index}].number`}
                              value={values.patents[index].number}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className={`${
                                values.patents.length > 1
                                  ? "col-span-5 border border-gray-300 rounded-xl p-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                  : "col-span-6 border border-gray-300 rounded-xl p-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                              }`}
                              placeholder="Patent number"
                            />
                            <input
                              type="text"
                              name={`patents[${index}].patentName`}
                              value={values.patents[index].patentName}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className={`${
                                values.patents.length > 1
                                  ? "col-span-5 border border-gray-300 rounded-xl p-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                  : "col-span-6 border border-gray-300 rounded-xl p-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                              }`}
                              placeholder="Patent name"
                            />
                            {values.patents.length > 1 && (
                              <button
                                type="button"
                                onClick={() => arrayHelpers.remove(index)}
                                className="col-span-2 px-3 py-2 rounded-xl bg-red-100 hover:bg-red-200 text-red-700 text-sm"
                              >
                                Remove
                              </button>
                            )}
                          </div>
                        ))}
                        <div className="mt-3">
                          <button
                            type="button"
                            onClick={() =>
                              arrayHelpers.push({ number: "", patentName: "" })
                            }
                            className="px-4 py-2 text-sm rounded-xl bg-blue-100 text-blue-600 hover:bg-blue-200"
                          >
                            + Add Patent
                          </button>
                        </div>
                      </div>
                    )}
                  />
                </div>
              </FormikProvider>
              </div>
              <div className="pt-4 border-t">
                <button
                  type="submit"
                  className="w-full py-3 rounded-xl bg-blue-600 text-white font-semibold hover:bg-blue-700"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
        <ToastContainer />
      </div>
    </>
  );
};
